import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useInView } from '../../hooks/useInView';
import { getRelatedTools } from '../../data/toolsData';

export default function RelatedTools({ currentSlug }) {
  const related = getRelatedTools(currentSlug);
  const [ref, inView] = useInView(0.1);

  if (!related.length) return null;

  return (
    <section className="py-20 sm:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-4">
            Related Tools
          </h2>
          <p className="text-slate-500 leading-relaxed">
            Explore more free file tools from FileMingle.
          </p>
        </div>

        <div
          ref={ref}
          className="grid grid-cols-1 sm:grid-cols-3 gap-6"
        >
          {related.map((tool, i) => (
            <Link
              key={tool.slug}
              to={`/${tool.slug}`}
              className="group rounded-2xl border border-slate-100 bg-white p-6 shadow-sm card-hover block"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(24px)',
                transition: `opacity 0.5s ease ${i * 0.1}s, transform 0.5s ease ${i * 0.1}s`,
              }}
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-bold tracking-widest uppercase text-brand-blue">
                  {tool.badge}
                </span>
                <ArrowRight
                  size={16}
                  aria-hidden="true"
                  className="text-slate-300 group-hover:text-brand-blue group-hover:translate-x-1 transition-all duration-200"
                />
              </div>
              <h3 className="font-bold text-slate-900 mb-2 group-hover:text-brand-blue transition-colors duration-200">
                {tool.h1}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed">{tool.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
